<template>
    <div>
        <div class="cover"></div>
        <div class="cover-img"><img src="https://act.mcake.com/fangli/static/images/icon/shouqing.png" alt=""></div>
    </div>
</template>

<script>
    export default {
        name: 'footer',
        data() {
            return {
                msg: '尾部导航'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover{
    position:absolute;
    top: 0;
    left: 0;
    width:100%;
    height:100%;
    background: #fff;
    opacity: 0.3;
    z-index: 1;
}
.cover-img{
    position:absolute;
    top: 50%;
    left:50%;
    width:40%;
    height:40%;
    margin-top: -20%;
    margin-left: -20%;
    z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/goods_over.vue